<template>
  <component :is="formConfig.templateCode" :formConfig="formConfig" :trackData="trackData" />
</template>
<script>
import suspensionCenter from './components/suspensionCenter.vue';
import { getChannelDetail } from "@/axios/applyForm/commonForm.js";
const testJson = '{"templateCode":"suspensionCenter","title":"购机咨询","backgroundImg":"https://market-cdn.anoah.com/dm/static/market-h5-clue/dynamicForm/template/suspensionCenter/form_bg.png","bannerImg":"https://market-cdn.anoah.com/dm/static/market-h5-clue/dynamicForm/template/suspensionCenter/form_banner.png","previewImg":"https://market-cdn.anoah.com/dm/static/market-h5-clue/dynamicForm/template/suspensionCenter/form_preview.png","submitMsg":"立即询价","tipMsg":"点击立刻询价后服务顾问会与你提交的手机号进行联系","hasRecommendedGuide":true,"hasLocationAuth":true,"agreements":[{"name":"《个人信息保护声明》","link":"https://youxueketang.anoah.com/yxp-page-manage/#/mobileContent?contentId=933"}],"fields":[{"name":"姓名","field":"name","required":true,"show":true,"maxLength":20,"type":"text"},{"name":"联系电话","field":"phone","required":true,"show":true,"maxLength":11,"type":"number","regx":"^1[3-9]\\\\d{9}$"},{"name":"验证码","field":"verifyCode","required":true,"show":true,"maxLength":10,"type":"verifyCode","phoneField":"phone"}]}';
const BURIEDPOINT_ACCESSPATH = {
  'WECHAT_APPLET_LINK': 'link',
  'WECHAT_APPLET_H5_LINK': 'h5link',
  'WECHAT_APPLET_QRCODE': 'QRCode'
}
export default {
  components: {
    suspensionCenter
  },
  data() {
    return {
      formConfig: {},
      trackData: {
        pageId: 50029,
        pageName: '推广计划表单落地页'
      }
    };
  },
  mounted() {
    const { spreadChannelId, spreadPlanId, spreadWay, unionId, openId, longitude, latitude } = this.$route.query;
    yxczxy.setOpenId(openId || '');
    yxczxy.setUnionId(unionId || '');
    this.$toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    getChannelDetail({ channelId: spreadChannelId }).then(res => {
      if (res.errcode === 0 && res.data) {
        if (res.data.topAgentId !== 0 && !res.data.topAgentId) return this.$toast('您访问的链接已失效')
        if (res.data.spreadPlanStatus !== 1) return this.$toast('您访问的链接已失效')
        this.formConfig = (res.data && res.data.styleConf) || JSON.parse(testJson);
        document.title = this.formConfig.title;
        this.trackData = {
          ...this.trackData,
          access_path: BURIEDPOINT_ACCESSPATH[spreadWay],
          longitude,
          latitude,
          plan_id: spreadPlanId,
          plan_name: res.data.spreadPlanName,
          channel_id: spreadChannelId,
          channel_name: res.data.name,
        }
        yxczxy.track('PAGE_EXPOSE', this.trackData);
        this.showTime = Date.now();
      } else {
        this.$toast(res.errmsg || '网络错误，请重试~')
      }
    }).finally(() => {
      this.$toast.clear();
    });
  },
  beforeDestroy() {
    if (this.showTime) {
      yxczxy.track('PAGE_EXIT', { ...this.trackData, duration: Date.now() - this.showTime });
    }
  }

};
</script>
